import { useState } from "react";
import { Alert, Col, Row } from "react-bootstrap";

function CardAlert({ tipo, close, children }) {

    const [show, setShow] = useState(true);

    

    if (close && show) {
        return (
            <Row style={{ marginTop: 15 }}>
                <Col md={6} className="mx-auto">
                    <Alert variant={tipo} className="text-center" onClose={() => setShow(false)} dismissible>
                        {children}
                    </Alert>
                </Col>
            </Row>
        );
    } else if(close && !show) {
        return ''
    }else{
        return (
            <Row style={{ marginTop: 15 }}>
                <Col md={6} className="mx-auto">
                    <Alert variant={tipo} className="text-center">
                        {children}
                    </Alert>
                </Col>
            </Row>
        );
    }

}

export default CardAlert;